import * as React from 'react';

import * as style from './style.css';

export interface IGallerySidebarLayoutProps {
  title: React.ReactNode;
  favoriteButton: React.ReactNode;
  price: React.ReactNode;
  buttons: React.ReactNode;
  author: React.ReactNode;
}

export const GallerySidebarLayout: React.FC<IGallerySidebarLayoutProps> = ({
  title,
  favoriteButton,
  price,
  buttons,
  author,
}) => {
  return (
    <div className={style['wrapper']}>
      <div className={style['title']}>
        {title}
        {favoriteButton}
      </div>

      {price}

      <div className={style['buttons']}>{buttons}</div>

      {author}
    </div>
  );
};
